import { PostPoliceReportQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/policeReport/postPoliceReport/policeReportQuery.type';
import { postPoliceReportFunction } from '@/modules/adjusterReportModules/adjusterReport/queries/policeReport/postPoliceReport/postPoliceReportQueryFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const postPoliceReportQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PostPoliceReportQueryParamsType
> => {
  return {
    mutationKey: ['policeReport'],
    mutationFn: (data: PostPoliceReportQueryParamsType) =>
      postPoliceReportFunction(data),
  };
};
